import React, { FC } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { CategoryCard } from "./CategoryCard";

interface ICategoriesListProps {
  categoriesList: { id: number; name: string, icon: string }[];
}

const useStyles = makeStyles(() => ({
  categoryCard: {
    minWidth: 600,
  },
}));

const CategoriesList: FC<ICategoriesListProps> = ({ categoriesList }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {categoriesList.map(({ id, name, icon }) => (
        <Grid item xs={12} sm={12} md={6} className={classes.categoryCard}>
          <CategoryCard
            key={id}
            id={id}
            name={name}
            icon={icon}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(CategoriesList);
